"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeSelector = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const design_system_1 = require("@hashintel/design-system");
const react_1 = require("react");
const TypeSelector = ({ searchText, onSearchTextChange, createModalPopupState, onAdd, onCancel, dropdownProps, options, inputRef, variant, }) => {
    const [open, setOpen] = (0, react_1.useState)(false);
    const highlightedRef = (0, react_1.useRef)(null);
    return ((0, jsx_runtime_1.jsx)(design_system_1.SelectorAutocomplete, { dropdownProps: dropdownProps, inputPlaceholder: `Search for a ${variant} type`, inputRef: inputRef, isOptionEqualToValue: (option, value) => option.$id === value.$id, optionToRenderData: ({ $id, title, description }) => ({
            typeId: $id,
            uniqueId: $id,
            title,
            description,
        }), open: open, onOpen: () => setOpen(true), onClose: (_, reason) => {
            if (reason !== "toggleInput") {
                setOpen(false);
            }
        }, inputValue: searchText, onInputChange: (_, value) => onSearchTextChange(value), onHighlightChange: (_, value) => {
            highlightedRef.current = value;
        }, onChange: (_, option) => {
            onAdd(option);
        }, 
        // Using onKeyUp to prevent a new line character being inputted into inputs in the modal
        onKeyUp: (evt) => {
            if (evt.key === "Enter" && !highlightedRef.current) {
                createModalPopupState?.open();
            }
        }, onKeyDown: (evt) => {
            if (evt.key === "Escape") {
                onCancel();
            }
        }, onBlur: () => {
            if (!createModalPopupState?.isOpen) {
                onCancel();
            }
        }, options: options }));
};
exports.TypeSelector = TypeSelector;
